import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RenderIf from '../../render-if/components/render-if';

import '../styles/default-header.css';

class DefaultHeader extends Component {
  render() {
    const { title, actionText, actionCallback } = this.props;
    const { t } = this.context;

    return (
      <div className="default-header-container">
        <p className="default-header-container__title">{t(title)}</p>
        <RenderIf if={actionText && actionCallback}>
          <p className="default-header-container__action" onClick={actionCallback}>
            {t(actionText)}
          </p>
        </RenderIf>
      </div>
    );
  }
}

DefaultHeader.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/app/shared/default-header/components/default-header.js